import { render, staticRenderFns } from "./TableUnityManagerBuyerPending.vue?vue&type=template&id=391a4ec6&"
import script from "./TableUnityManagerBuyerPending.vue?vue&type=script&lang=ts&"
export * from "./TableUnityManagerBuyerPending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports